import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import BluelabpHProbe from "../../Assets/Bluelab pH Probe.webp";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Bluelab_pH_Probe = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 17,
      name: "Bluelab pH Probe",
      price: 6384,
      image: BluelabpHProbe,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={BluelabpHProbe}
                  alt="Product 1"
                  className="d-block w-100"
                />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Bluelab pH Probe</h2>
            <p className="product-price">₹{6384}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3 text-justify">
              <h5>
                Durable Double-Junction pH Probe for Long-Lasting Performance
              </h5>
              <ul>
                <li>
                  Designed with double-junction technology to minimize
                  contamination and enhance the probe’s lifespan.
                </li>
                <li>
                  Fully waterproof, offering superior protection compared to
                  water-resistant alternatives.
                </li>
                <li>
                  Equipped with a BNC connector, ensuring compatibility with all
                  Bluelab and Autogrow products.
                </li>
                <li>
                  Includes a 2-meter cable, making it easy to reach and measure
                  in difficult or distant locations.
                </li>
                <li>
                  Comes with a KCl-filled storage cap to help maintain and
                  extend the life of the probe.
                </li>
                <li>
                  Provides rapid sensor response for fast, accurate pH
                  measurements.
                </li>
                <li>
                  Built with sturdy polycarbonate housing to withstand tough
                  conditions.
                </li>
                <li>
                  Suitable for use in solutions with an EC of 0.2 or higher.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Bluelab_pH_Probe;
